<form [formGroup]="form">
  <div class="sections">
    <section>
      <mat-form-field appearance="outline">
        <mat-label>Username</mat-label>
        <input matInput formControlName="username" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Full Name</mat-label>
        <input matInput formControlName="fullName" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>SAP ID</mat-label>
        <input matInput formControlName="sapId" />
      </mat-form-field>
    </section>
  </div>
  <div class="actions">
    <button mat-flat-button (click)="onCancel()">Cancel</button>
    <button color="primary" [disabled]="!form.valid" mat-flat-button (click)="onAdd()">Add</button>
  </div>
</form>
